import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class CobbledRoadTileEntity extends TileEntity {
	public static readonly frameName = FrameName.COBBLED_ROAD;
}

export default CobbledRoadTileEntity;
